import { useQuery } from '@tanstack/react-query';

import { productionPayrollApi, productionPayrollKeys } from '@/api/productionPayroll';
import { useAuth } from '@/hooks/useAuth';

export const PRODUCTION_PAYROLL_PATH = '/webadmin/app/production/payroll';

export function isProductionPayrollPath(pathname: string): boolean {
  return pathname === PRODUCTION_PAYROLL_PATH || pathname.startsWith(`${PRODUCTION_PAYROLL_PATH}/`);
}

/**
 * Payroll page access: administrators always; other users only with a grant (MD-0097).
 * Closing and reopening a month stays with administrators.
 */
export function useProductionPayrollAccess() {
  const { user, status } = useAuth({ skipInitialCheck: true });
  const isAdmin = user?.role === 'admin';

  const query = useQuery({
    queryKey: productionPayrollKeys.access(),
    queryFn: () => productionPayrollApi.access(),
    enabled: status === 'authenticated' && !isAdmin,
    staleTime: 60_000,
  });

  if (isAdmin) return { canUse: true, isLoading: false };
  return {
    canUse: query.data?.can_use === true,
    isLoading: status === 'authenticated' && query.isLoading,
  };
}
